import getMLRFormatTab from './mlr-format-tab/getMLRFormatTab';
import getMLRHomeTab from './mlr-home-tab/getMLRHomeTab';
import getMLRInsertTab from './mlr-insert-tab/getMLRInsertTab';
import getMLRMessageTab from './mlr-message-tab/getMLRMessageTab';
import getMLRNotesTab from './mlr-notes-tab/getMLRNotesTab';
import getMLRViewTab from './mlr-view-tab/getMLRViewTab';
import getMLRTableFormatTab from './mlr-table-format-tab/getMLRTableFormatTab';
import { ComposeViewState } from 'owa-mail-compose-store';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { getMailMenuItemShouldShowMap, MenuItemType } from 'owa-mail-filterable-menu-behavior';
import { getMainWindowComposeViewState } from 'owa-mail-compose-actions/lib/selectors/getMainWindowComposeViewState';
import { isFeatureEnabled } from 'owa-feature-flags';
import type {
    RibbonTabDefinitionBase,
    RibbonTabDefinitionSet,
} from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components';
import type { RibbonControlDefinitionProps } from 'owa-mail-ribbon-utils';

export const getMailRibbonDefinitionsMLR = computedFn(
    (props: RibbonControlDefinitionProps): RibbonTabDefinitionSet => {
        const tabs: RibbonTabDefinitionBase[] = [];
        const viewState: ComposeViewState | undefined = getMainWindowComposeViewState();
        const shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
        const isNotesFolder = shouldShowBehaviorMap[MenuItemType.Ribbon_NewNote]();

        tabs.push(getMLRHomeTab(props));
        tabs.push(getMLRViewTab(props));

        if (viewState && !viewState.isInlineCompose) {
            tabs.push(getMLRMessageTab(props));
            if (isFeatureEnabled('cmp-ribbonInsertTab')) {
                tabs.push(getMLRInsertTab(props));
            }
            if (isFeatureEnabled('cmp-ribbonFormatTextTab')) {
                tabs.push(getMLRFormatTab(props));
            }
            if (isFeatureEnabled('cmp-table-styling')) {
                tabs.push(getMLRTableFormatTab(props));
            }
        }

        if (isNotesFolder) {
            tabs.push(getMLRNotesTab(props));
        }

        return {
            tabs: tabs,
        };
    }
);
